import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const useRoleSetupTranslationRef = createTranslationRef({
  id: 'user-role-setup',
  messages: {
    button: {
      next: 'Next',
      back: 'Back',
      submit: 'Submit',
      save: 'Save',
    },
    roleSetup: {
      headerTitle: 'Choose your role',
      headerDesc1: 'Choose the closest match to your current job function.',
      headerDesc2:
        'This information helps to personalize your experience on XELERATE.',
      info: 'Your Role can be changed anytime in the settings page',
    },
    researchPanelInterest: {
      headerTitle: 'Shape The Tools You Use Every Day',
      headerDesc1:
        "Give us 30 minutes once a quarter to tell us exactly what's broken, slow, or",
      headerDesc2: 'annoying you. We listen and we fix it.',
      info: 'This can be changed anytime in the settings page',
    },
    editRoleInfoModal: {
      headerTitle: 'Edit Profile',
      role: 'Role',
      researchPanelInterestLabel: 'User Research Panel',
    },
  },
});
